import { css } from 'lit-element';

export const kwCardEventStyles = css`
  :host {
    --color-design: var(--color-design-capacity, #23B77E);
    --color-devops: var(--color-devops-capacity, #B92E52);
    --color-agile: var(--color-agile-capacity, #E4AF43);
    --color-dev: var(--color-dev-capacity, #035762);
    --color-dat: var(--color-dat-capacity, #620356);
    --color-innova: var(--color-innova-capacity, #56BAC7);
    --color-primary-default: var(--color-primary, #FF7900);
    display: block;
    font-family: 'AvenirLTPro', sans-serif;
    font-size: 18px;
    color: var(--color-grey-dark, var(--color-grey-dark));
    line-height: 31px;
  }
  .font__weight--900 {
    font-weight: 900;
    font-family:'AvenirLTPro-Heavy';
  }
  h3 {
    font-family: 'HelveticaNeueBold';
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    color: #4D4D4E;
    line-height: 24px;
    margin-top: 20px;
  }
  .design {
    border-bottom: 4px solid var(--color-design);
  }
  .devops {
    border-bottom: 4px solid var(--color-devops);
  }
  .agile {
    border-bottom: 4px solid var(--color-agile);
  }
  .dev {
    border-bottom: 4px solid var(--color-dev);
  }
  .data {
    border-bottom: 4px solid var(--color-dat);
  }

  .innova {
    border-bottom: 4px solid var(--color-innova);
  }

  .kairos, .corporate {
    border-bottom: 4px solid var(--color-primary-default);
  }
  .kw-card-event__container-description--medium[hidden] {
    display: none;
  }

/* Small Size*/
.kw-card-event__container-item--small {
  position: relative;
  margin-left: 75px;
  margin-bottom: 48px;
}
.kw-card-event__container-img {
  position: absolute;
  right: 110%;
  top: 0;
  margin-left: 2px;
}
.kw-card-event__continer-title {
  max-width: 264px;
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 15px;
}
.kw-card-event__title--small {
  font-size: 14px;
  margin-bottom: 0px;
  line-height: 24px;
  margin-top: 0;
}
.kw-card-event__subtitle--small {
  margin-top: 0;
  font-size: 14px;
  margin-bottom: 6px;
  line-height: 24px;
}

.kw-card-event__speaker--small {
  font-family: 'AvenirLTPro', sans-serif;
}
.kw-card-event__container-date--small {
  display: flex;
  justify-content: space-between;
  max-width: 500px;
  font-family:'AvenirLTPro-Heavy';
}
.kw-card-event__type {
  text-align: right;
  text-transform: capitalize;
}
/* Medium size */
.kw-card-event__item-container--medium {
  width: 100%;
  margin-bottom: 65px;
}
.kw-card-event__img--medium {
  width: 100%;
}
.kw-card-event__subtitle--medium {
  line-height: 25px;
  text-transform: capitalize;
}
.kw-card-event__title--medium {
  margin-bottom: 16px;
  font-size: 16px;
}
.kw-card-event__container-date--medium {
  font-weight: 800;
  line-height: 25px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.down-arrow-icon {
  width: 30px;
  height: 30px;
  border: none;
  margin: 16px;
  background-color: transparent;
  background-image: url(/assets/images/icon-arrow-down.svg);
  background-position: center;
  background-repeat: no-repeat;
}
.up-arrow-icon {
  width: 30px;
  height: 30px;
  border: none;
  margin: 16px;
  background-color: transparent;
  background-image: url(/assets/images/icon-arrow-up.svg);
  background-position: center;
  background-repeat: no-repeat;
}
.kw-card-event__container-description--medium {
  display: flex;
  flex-direction: column;
}
.kw-card-event__container-img--medium {
  position:relative;
  overflow: hidden;
  
}

.kw-card-event__img-gout--medium {
  position: absolute;
  width: 93px;
  z-index: 2;
  left: -4px;
  top: -11px;
}

/* Large */
.kw-card-event__item--large {
  position: relative;
  margin-bottom: 88px;
}
.kw-card-event__container-img--large{
  height: 180px;
}
.kw-card-event__img--large {
  position: relative;
  z-index: 0;
  width: 100%;
}
.kw-card-event__img-gout--large {
  position: relative;
  z-index: 1;
  margin-top: 45px;
  bottom: 107px;
  left: 15px;
  width: 112px;
}
.kw-card-event__container-date--large {
  position: absolute;
  right: 0px;
  top: 116px;
  text-align: right;
}

.kw-card-event__container-date--large div {
  height: 25px;
}
.kw-card-event__container-info--large {
  margin-bottom: 32px;
}
.kw-card-event__container-description--large {
  display: flex; 
  flex-direction: column;
}
.kw-card-event__container-description--large p {
  display: none;
}

.kw-card-event__container-data--large {
  display: flex;
  flex-direction: column;
}
.kw-card-event__container-link--medium {
  width: 94px;
  height: 35px;
  border: 2px solid rgb(14, 53, 64);
  border-radius: 5px;
  font-size: 16px;
  font-weight: 700;
  color: var(--color-secondary);
  background: transparent;
  text-transform: uppercase;
  align-self: flex-end;
  box-sizing: border-box;
  text-align: center;
  padding: 2px 0 0 0;
  margin-bottom: 20px;
  text-decoration: none;
}
.kw-card-event__container-link--large {
  width: 155px;
  height: 35px;
  border: 2px solid rgb(14, 53, 64);
  border-radius: 5px;
  font-size: 16px;
  font-weight: 700;
  color: var(--color-secondary);
  background: transparent;
  text-transform: uppercase;
  align-self: flex-end;
  box-sizing: border-box;
  text-align: center;
  padding: 2px 0 0 0;
  margin-bottom: 20px;
  text-decoration: none;
}

.kw-card-event__link-title {
  text-decoration: none;
}

.kw-card-event__link-title h3:hover {
  cursor: pointer;
  color: var(--color-primary-default, #FF7900)
}

/* Desktop */
@media all and (min-width: 1024px) {
  h3 {
    font-size: 18px;
    margin-top: 0px;
  }
  .text__align--end {
    text-align: end;
    position: static;
  }
  .kw-card-event__type {
    text-align: left;
  }
    /* Small size */
  .kw-card-event__list--small {
    display: grid;
    column-gap: 33px;
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 148px;
  }
  .kw-card-event__list--small:last-child {
    margin-bottom: 108px;
  }
  .kw-card-event__continer-title{
    margin-left: 0;
  }
  .kw-card-event__container-item--small {
    height: 210px;
    padding-bottom: 13px;
    display: flex;
    margin-bottom: 98px;
    margin-left: 0;
  }
  .kw-card-event__item--small {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }
  .kw-card-event__title--small {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 2px;
  }
  .kw-card-event__speaker--small {
    font-weight: 800;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 1px;
  }
  .kw-card-event__container-date--small {
    font-family: 'AvenirLTPro-Light';
    display: flex;
    flex-direction: column;
    max-width: 80%;
  }
  .kw-card-event__container-img {
    position: absolute;
    bottom: 0px;
    right: 0px;
    top: initial;
    align-self: flex-end;
  }
    /* Medium size */
  .kw-card-event__container-description--medium[hidden] {
    display: block;
  }
  .kw-card-event__container-button--medium {
    display: none;
  }
  .kw-card-event__container-link--medium {
    display: none;
  }
  .kw-card-event__item-container--medium {
    margin-bottom: 82px;
    height: 510px;
  }
  .kw-card-event__container-img--medium {
    margin-bottom: 23px;
  }
  .kw-card-event__img--medium {
    width: 100%;
  }
  .kw-card-event__img--medium {
    margin: 0;
  }
  .kw-card-event__container-data--medium {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .kw-card-event__container-info-left--medium {
    width: 75%;
  }
  .kw-card-event__title--medium {
    letter-spacing: 2.1px;
    margin-bottom: 0;
    line-height: 24px;
  }
  .kw-card-event__subtitle--medium {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .kw-card-event__separator--medium {
    border-left: 2px solid var(--color-grey-dark);
    margin: 0 15px;
    height: 14px;
  }
  .kw-card-event__container-date--medium {
    font-family: 'AvenirLTPro-Light';
    letter-spacing: 1px;
    justify-content: space-between;
    line-height: 25px;
    margin-top: 0;
  }
  .kw-card-event__container-description--medium {
    margin: 35px 0 26px 0;
  }
  .kw-card-event__container-description--medium p {
    line-height: 31px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }
   /* Large */
   .kw-card-event__item--large {
    height: 100%;
  }
   .kw-card-event__container-info--large h3 {
    font-size: 22px;
    margin-bottom: 0;
  }
  .kw-card-event__img-gout--large {
    bottom: 135px;
  right: -24px;
  }
   .kw-card-event__container-img--large {
    height: 381px;
  }
   .kw-card-event__container-data--large {
    display: grid;
    column-gap: 32px;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 25px;
    min-height: 160px;
  }
  .kw-card-event__container-info--large {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 0;
  }
  .kw-card-event__container-info-left--large {
    display: flex;
    justify-content: space-between;
    letter-spacing: 1px;
  }
  .kw-card-event__container-description--large p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    margin: 0;
  }
  .kw-card-event__container-link--large {
    margin-bottom: 0;
  }

  .kw-card-event__container-description--large {
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
  }
  
  .kw-card-event__img-gout--medium {
    width: 94px;
    left: -2px;
    top: -10px;
  }
}

@media all and (max-width: 700px) {
  .kw-card-event__container-item--small {
    border: none;
  }
  .kw-card-event__item-container--medium {
    border: none;
  }


}
`;
